import exifr from 'exifr';

export async function extractGpsFromPhoto(file: File) {
  try {
    const gps = await exifr.gps(file);
    if (gps?.latitude && gps?.longitude) {
      return { lat: gps.latitude, lng: gps.longitude };
    }
    return null;
  } catch {
    return null;
  }
}

export interface PhotoMetadata {
  gps: { lat: number; lng: number } | null;
  altitude: number | null;
  dateTaken: Date | null;
  camera: string | null;
  dimensions: { width: number; height: number } | null;
}

export async function extractPhotoMetadata(file: File): Promise<PhotoMetadata> {
  try {
    const [gps, exif] = await Promise.all([
      exifr.gps(file).catch(() => null),
      exifr.parse(file, ['GPSAltitude', 'DateTimeOriginal', 'Make', 'Model', 'ImageWidth', 'ImageHeight']).catch(() => null),
    ]);
    return {
      gps: gps?.latitude && gps?.longitude ? { lat: gps.latitude, lng: gps.longitude } : null,
      altitude: exif?.GPSAltitude ?? null,
      dateTaken: exif?.DateTimeOriginal || null,
      camera: [exif?.Make, exif?.Model].filter(Boolean).join(' ') || null,
      dimensions: exif?.ImageWidth && exif?.ImageHeight ? { width: exif.ImageWidth, height: exif.ImageHeight } : null,
    };
  } catch {
    return { gps: null, altitude: null, dateTaken: null, camera: null, dimensions: null };
  }
}
